import React from 'react';
import AdminQuizPage from '../../body/AdminQuizPage';
import { ADMIN_QUIZ_MODULES } from '../../../../apis/quiz';

const introContent = (
  <div className='space-y-4 text-left'>
    <p className='font-bold text-2xl'>
      Congratulations! You have finished Program Strategies Part 2 and have now
      learned all the core strategies of the parenting program!
    </p>
    <p className='text-xl leading-relaxed'>
      To move on to the next module, a score of <b>80%</b> or higher on the quiz
      is required.
    </p>
    <div>
      <p className='text-xl leading-relaxed'>
        <b>Instructions:</b> Answer the following questions by choosing the one
        best answer. A score of <b>80%</b> is required to move on to the next
        training module.
      </p>
    </div>
  </div>
);

const Mod3Quiz = () => (
  <AdminQuizPage
    moduleKey={ADMIN_QUIZ_MODULES.strategiesPart2}
    title='End of Module Test'
    introContent={introContent}
    pdfSrc='/resource-library/ProgramStrategiesI&II.pdf'
    pdfText='Program Strategies Part 1 and 2'
  />
);

export default Mod3Quiz;

